export default __webpack_public_path__ + "static/media/Delta.c34fc280.png";